import PolyMap from '../model/PolyMap';
import ScalarArrayView from '../../generic/container/ScalarArrayView';
import SimpleFanTriangulation from '../algorithm/SimpleFanTriangulation';
import applyFunctionToPolyMap from './applyFunctionToPolyMap';

export default function triangulateMesh(polyMesh) {

  function triangulateMap(polyMap, polyMapName, additionalArguments) {
    const newFaceRangeOffsets = additionalArguments.newFaceRangeOffsets;
    const triangulation = additionalArguments.triangulation;

    const result = new ScalarArrayView(triangulation.numTriangles * 3);
    triangulation.translateIndices(polyMap.faceValueIndices, result);
    const newFaceValueIndices = result.data;

    return new PolyMap({
      faceRangeOffsets: newFaceRangeOffsets,
      faceValueIndices: newFaceValueIndices,
      values: polyMap.values,
    });
  };

  const triangulation = new SimpleFanTriangulation(polyMesh);

  const newFaceRangeOffsets = new Uint32Array(triangulation.numTriangles + 1);
  for (let i = 1; i < newFaceRangeOffsets.length; i++) {
    newFaceRangeOffsets[i] = newFaceRangeOffsets[i - 1] + 3;
  }

  const args = { newFaceRangeOffsets, triangulation };
  return applyFunctionToPolyMap(polyMesh, triangulateMap, args).topologyChanged();
};



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/operator/triangulateMesh.js